import { Game } from "phaser";
import RoundRectanglePlugin from 'phaser3-rex-plugins/plugins/roundrectangle-plugin.js';
//import { ScrollablePanel } from 'phaser3-rex-plugins/templates/ui/ui-components.js';
import UIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin.js';
import WebFontLoaderPlugin from 'phaser3-rex-plugins/plugins/webfontloader-plugin.js';



import { Preloader } from "./preloader";
import { HudScene } from "./scenes/HudScene";
import { MainScene } from "./scenes/MainScene";
import { MenuScene } from "./scenes/MenuScene";
import { SplashScene } from "./scenes/SplashScene";
import { TimerScene } from "./scenes/TimerScene";
import { HistoryScene } from "./scenes/HistoryScene";
import { InfoScene } from "./scenes/InfoScene";
import { BuyTicketScene } from "./scenes/BuyTicketScene";
import { QuickPickScene } from "./scenes/QuickPickScene";
import { ManualPickScene } from "./scenes/ManualPickScene";
import { ErrorScene } from "./scenes/ErrorScene";
import { MyTicketsScene } from "./scenes/MyTicketsScene";
import { BalanceAlertScene } from "./scenes/BalanceAlertScene";
import { ResultsScene } from "./scenes/ResultsScene";
import { DetailsScene } from "./scenes/DetailsScene";
import { ErrorPopScene } from "./scenes/ErrorPopScene";


const dpr = Math.min(window.devicePixelRatio, 3); // cap if you wish
console.log("dpr", dpr);

const config = {
    type: Phaser.WEBGL,
    parent: "phaser-container",
    width: 750, //650,
    height: 1476, //1280,
    backgroundColor: "#000000",
    resolution: dpr,
    render: {
        preserveDrawingBuffer:true,
        powerPreference: "high-performance"
        
    },
    dom: {
        createContainer: true
    },
    plugins: {
        scene: [{
            key: 'rexUI',
            plugin: UIPlugin,
            mapping: 'rexUI'
        },
        // ...
        ],
        global: [{
            key: 'rexRoundRectanglePlugin',
            plugin: RoundRectanglePlugin,
            start: true
            },
            {
                key: 'rexWebFontLoader',
                plugin: WebFontLoaderPlugin,
                mapping: 'rexWebFontLoader',
                start: true
            }
            // {
            // key: 'rexUI',
            // plugin: UIPlugin,
            // mapping: 'rexUI'
            // }
        ]
    },
    scale: {
        //mode: Phaser.Scale.RESIZE,
        mode: Phaser.Scale.EXPAND,//EXPAND
        autoCenter: Phaser.Scale.CENTER_BOTH,
        autoRound: true,
        // min: {width: 325, height: 640},
        max: {width: 830, height: 1476},
        //expandParent: true
    },
    // physics: {
    //     default: "arcade",
    //     arcade: {
    //         gravity: { y: 0 }
    //     }
    // },
    scene: [
        Preloader,
        SplashScene,
        MainScene,
        MenuScene,
        HudScene,
        TimerScene,
        HistoryScene,
        InfoScene,
        BuyTicketScene,
        QuickPickScene,
        ManualPickScene,
        ErrorScene,
        MyTicketsScene,
        BalanceAlertScene,
        ResultsScene,
        DetailsScene,
        ErrorPopScene
    ]
};






// Wait for the window to load
window.onload = function() {
    // Step 1: Read query parameters
    const queryString = window.location.search;
    
    const urlParams = new URLSearchParams(queryString);
    
    // Step 2: Convert to an object and store in localStorage
    const paramsObject = {};
    urlParams.forEach((value, key) => {
      paramsObject[key] = value;
    });
    localStorage.setItem('gameParams', JSON.stringify(paramsObject));

    const game  = new Game(config); 


    function resizeGame() {
        let height = window.iOSInnerHeight ? window.iOSInnerHeight() : window.innerHeight;
        let width = window.innerWidth;
    
        let windowRatio = width / height;
        let gameRatio = game.config.width / game.config.height;
    
        if (windowRatio < gameRatio) {
            
            game.canvas.style.width = width + 'px';
            game.canvas.style.height = (width / gameRatio) + 'px';
        } else {
            
            game.canvas.style.width = (height * gameRatio) + 'px';
            game.canvas.style.height = height + 'px';
        }
    }


    // Call resizeGame on load and resize events
    window.addEventListener('resize', resizeGame);
    resizeGame(); // Initial resize

    

        // window.addEventListener('resize', () => {
        //     adjustGameSize(game);
        // });

        // function adjustGameSize(game) {
        //     const maxAspectRatio = 2; // 2:1 aspect ratio
        //     const minAspectRatio = 1.5; // Allow some expansion in width for wider screens

        //     const windowWidth = window.innerWidth;
        //     const windowHeight = window.innerHeight;
        //     const aspectRatio = windowWidth / windowHeight;

        //     let newWidth, newHeight;

        //     if (aspectRatio > maxAspectRatio) {
        //         // If the screen is much wider than 2:1, use a width with the max 2:1 ratio
        //         newWidth = windowHeight * maxAspectRatio;
        //         newHeight = windowHeight;
        //     } else if (aspectRatio < minAspectRatio) {
        //         // If the screen is taller or narrow, restrict width with min aspect ratio
        //         newWidth = windowHeight * minAspectRatio;
        //         newHeight = windowHeight;
        //     } else {
        //         // Default behavior (2:1 ratio)
        //         newWidth = windowWidth;
        //         newHeight = windowHeight;
        //     }

        //     game.scale.resize(newWidth, newHeight);
        // }


}


// Function to resize the game to fit the visible viewport, excluding the browser UI
// function resizeGame() {
//     const canvas = game.canvas;
//     const width = window.innerWidth;
//     const height = window.innerHeight;

//     const windowRatio = width / height;
//     const gameRatio = game.config.width / game.config.height;

//     if (windowRatio < gameRatio) {
//         canvas.style.width = width + 'px';
//         canvas.style.height = (width / gameRatio) + 'px';
//     } else {
//         canvas.style.width = (height * gameRatio) + 'px';
//         canvas.style.height = height + 'px';
//     }
// }

// // Call it initially to ensure the game fits the screen from the start
// resizeGame();

// // Listen for window resize events to handle changes in viewport height
// window.addEventListener('resize', () => {
//     //resizeGame();
// });



//// THE CORRECT ONE


